




















































































import Vue from 'vue'
import * as R from 'ramda'
import PatientStatsDetailedInhalerLegend from '@/components/patient-stats/graphs/detailed-reports/PatientStatsDetailedInhalerLegend.vue'
import { DataPoint, InhalerTypes, InhalerUsage } from '@/jsonapi/CommonTypes'
import { USER_TIME_ZONE } from '@/utils/time'
import { buildInhalerUsageOptions } from '@/components/patient-stats/graphs/detailed-reports/options/inhaler-usage-options'
import { buildNightTimeInhalerUsageOption } from '@/components/patient-stats/graphs/detailed-reports/options/night-time-inhaler-usage-options'
import { buildOverUsageOptions } from '@/components/patient-stats/graphs/detailed-reports/options/over-usages-options'
import { buildInhalerUsageDurationOptions } from '@/components/patient-stats/graphs/detailed-reports/options/inhaler-usage-duration-options'
import { buildInhalerPuffsOptions } from '@/components/patient-stats/graphs/detailed-reports/options/inhaler-puffs-options'

export default Vue.extend({
  components: {
    PatientStatsDetailedInhalerLegend,
  },
  props: {
    startTimestamp: {
      type: Number,
      required: true,
    },
    endTimestamp: {
      type: Number,
      required: true,
    },
    patientWithDetailedReports: {
      type: Object,
      default: null,
    },
  },
  computed: {
    isNoData(): boolean {
      return (
        !this.rescueInhalerUsages.length &&
        !this.nightRescueInhalerUsages.length &&
        !this.rescueInhalerUsageDurations.length
      )
    },
    inhalerUsages(): InhalerUsage[] {
      return R.pathOr([], ['inhalersReport', 'inhalerUsages'], this.patientWithDetailedReports)
    },
    rescueInhalerUsages(): InhalerUsage[] {
      return this.inhalerUsages.filter(usage => usage.type === InhalerTypes.Reliever)
    },
    inhalerUsagesDataPointsLength(): number {
      return this.rescueInhalerUsages.reduce((acc, usage) => acc + usage.dataPoints.length, 0)
    },
    rescueInhalerUsageDurations(): InhalerUsage[] {
      return R.pathOr([], ['inhalersReport', 'inhalerUsageDurations'], this.patientWithDetailedReports).filter(
        usage => usage.type === InhalerTypes.Reliever
      )
    },
    nightRescueInhalerUsages(): InhalerUsage[] {
      return R.pathOr([], ['inhalersReport', 'nightInhalerUsages'], this.patientWithDetailedReports).filter(
        usage => usage.type === InhalerTypes.Reliever
      )
    },
    nightInhalerUsagesDataPointsLength(): number {
      return this.nightRescueInhalerUsages.reduce((acc, usage) => acc + usage.dataPoints.length, 0)
    },
    overUsages(): DataPoint[] {
      return R.pathOr([], ['inhalersReport', 'overUsages'], this.patientWithDetailedReports)
    },
    buildOptions(): { resultStartTimestamp: number; resultEndTimestamp: number; timezone: string; colors: any } {
      const { resultStartTimestamp, resultEndTimestamp } = this.patientWithDetailedReports
      const timezone = this.patientWithDetailedReports.timezone || USER_TIME_ZONE
      return {
        resultStartTimestamp,
        resultEndTimestamp,
        timezone,
        colors: this.$vuetify.theme.themes.light,
      }
    },
    inhalerUsageOptions(): echarts.EChartOption<echarts.EChartOption.SeriesBar> {
      return buildInhalerUsageOptions({
        ...this.buildOptions,
        inhalerUsages: this.rescueInhalerUsages,
        threshold: 2,
      })
    },
    inhalerUsageOptionsForPuffs(): echarts.EChartOption<echarts.EChartOption.SeriesBar> {
      return buildInhalerPuffsOptions({
        ...this.buildOptions,
        inhalerUsages: this.rescueInhalerUsages,
      })
    },
    inhalerUsageDurationOptions(): echarts.EChartOption<echarts.EChartOption.SeriesBar> {
      return buildInhalerUsageDurationOptions({
        ...this.buildOptions,
        inhalerUsageDurations: this.rescueInhalerUsageDurations,
      })
    },
    nighTimeInhalerUsageOptions(): echarts.EChartOption<echarts.EChartOption.SeriesBar> {
      return buildNightTimeInhalerUsageOption({
        ...this.buildOptions,
        nightInhalerUsages: this.nightRescueInhalerUsages,
        nightInhalerUsagesDataPointsLength: this.nightInhalerUsagesDataPointsLength,
      })
    },
    overUsagesChartOptions(): echarts.EChartOption<echarts.EChartOption.SeriesCustom> {
      return buildOverUsageOptions({
        ...this.buildOptions,
        overUsages: this.overUsages,
      })
    },
  },
})
